import { commonAxios, clientAxios } from '@/plugins/axios'

export const getCardList = ({ customer_id, card_seq = undefined }) =>
  commonAxios.get('/v1/common/mypage/card/list', {
    params: {
      customer_id,
      card_seq,
    },
  })

export const newCard = ({ token, gmo_id, card_seq = undefined, card_info, customer_id }) =>
  commonAxios.post('/v1/common/mypage/card/register', { token, gmo_id, card_seq, card_info, customer_id })

export const updateCard = ({ gmo_id, card_seq, expire, holder_name, card_info }) =>
  commonAxios.post('/v1/common/mypage/card/update', { gmo_id, card_seq, expire, holder_name, card_info })

export const getMyPageEnableinfo = () => clientAxios.get(`/v1/setting/shop/detail/mypage`)
